module.exports = __webpack_public_path__ + "img/meating2.302004af.jpg";